import { Direction } from '@lendi-ui/checkbox/dist/declarations/src/CheckboxGroup/index.style';
import * as React from 'react';
import { Field as FinalField, useForm } from 'react-final-form';
import { includes } from 'lodash';
import { CheckboxGroup, CheckboxGroupItemProps, CheckboxGroupProps } from '@lendi-ui/checkbox';
import Field from '@lendi-ui/field';

import { FieldLabel } from '../_common/FieldLabel';
import { FieldWrapper } from '../_common/style';
import { CommonFieldProps } from '../_common/types';

export interface CheckboxesFieldProps extends CommonFieldProps, Omit<CheckboxGroupProps, 'onChange' | 'values'> {
  checkboxes: CheckboxGroupItemProps[];
  onChange?: (value: CheckboxGroupItemProps['value'][]) => boolean | void;
  values?: string[];
  dedupe?: boolean;
  direction?: Direction;
  isOptional?: boolean;
}

const CheckboxesField = (props: CheckboxesFieldProps) => {
  const {
    checkboxes,
    isOptional,
    label,
    labelAfter,
    name,
    subLabel,
    values = [],
    disableFailMessage = false,
    dedupe,
    onChange,
    direction,
    ...rest
  } = props;
  const form = useForm();

  const isChecked = (value: string) => includes(values, value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const changedValue = e.target.value;

    const newChecked = isChecked(changedValue)
      ? values.filter((selected: string) => selected !== changedValue)
      : [...values, changedValue];

    const checkedItems = dedupe ? Array.from(new Set(newChecked)) : newChecked;

    if (onChange) {
      onChange(checkedItems);
    } else {
      // Set in parent form
      form.change(name, checkedItems);
    }
  };

  const fieldProps = {
    name,
  };

  return (
    <FieldWrapper>
      <FieldLabel label={label} labelAfter={labelAfter} subLabel={subLabel} isOptional={isOptional} />
      <FinalField {...fieldProps}>
        {({ input, meta }) => (
          <Field {...meta} error={disableFailMessage ? undefined : meta.error}>
            <CheckboxGroup
              {...rest}
              data-component={name}
              values={values}
              direction={direction}
              onChange={handleChange}
            >
              {checkboxes.map((checkbox, index) => (
                <CheckboxGroup.Checkbox key={index} {...checkbox} />
              ))}
            </CheckboxGroup>
          </Field>
        )}
      </FinalField>
    </FieldWrapper>
  );
};

export default CheckboxesField;
